export const UserActionTypes = {
  LOADING_API: 'LOADING_API',
  LOADING_USER: 'LOADING_USER',
  UPDATE_USER: 'UPDATE_USER',
  LOADING_VERIFY: 'LOADING_VERIFY',
  EMAIL_SIGN_IN_START: 'EMAIL_SIGN_IN_START',
  SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
  SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',
  CHECK_USER_SESSION: 'CHECK_USER_SESSION',
  SIGN_OUT_SUCCESS: 'SIGN_OUT_SUCCESS',
  SIGN_OUT_FAILURE: 'SIGN_OUT_FAILURE',
  SIGN_OUT_START: 'SIGN_OUT_START',
  SIGN_UP_SUCCESS: 'SIGN_UP_SUCCESS',
  SIGN_UP_FAILURE: 'SIGN_UP_FAILURE',
  SIGN_UP_START: 'SIGN_UP_START',
  VERIFY_SUCCESS: 'VERIFY_SUCCESS',
  VERIFY_FAILURE: 'VERIFY_FAILURE',
  VERIFY_START: 'VERIFY_START',
  REQUEST_VERIFY_START: 'REQUEST_VERIFY_START',
  UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_FAILURE: 'UPDATE_PASSWORD_FAILURE',
  UPDATE_PASSWORD_START: 'UPDATE_PASSWORD_START',
  UPDATE_INFO_SUCCESS: 'UPDATE_INFO_SUCCESS',
  UPDATE_INFO_FAILURE: 'UPDATE_INFO_FAILURE',
  UPDATE_INFO_START: 'UPDATE_INFO_START',
  SAVE_JOB_START: 'SAVE_JOB_START',
  UPDATE_LIST_CV_IN_USER: 'UPDATE_LIST_CV_IN_USER',
  DELETE_CV_IN_USER: 'DELETE_CV_IN_USER',
  VIEW_NOTI: 'VIEW_NOTI',
};
